<template>
  <el-drawer :visible="visible" title="短信发送" @close="close">
    <el-form :model="smsDialog">
      <el-table :data="tableData" class="contacts-info" style="width: 100%; margin-bottom: 15px"
        @selection-change="handleSmsReceiverListChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="phone" label="号码" />
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="relation" label="关系" />
      </el-table>
      <!-- <el-form-item
        
        label="手动输入号码"
        prop="phone"
      >
        <el-input
          v-model="smsDialog.phone"
          placeholder="请填写"
          type="number"
          style="width: 144px"
        />
      </el-form-item> -->
      <el-form-item label="选择短信模板">
        <el-select v-model="smsDialog.template"  placeholder="请选择..." @change="handleSmsTemplateChange">
          <el-option v-for="template in smsTemplates" :key="template.id" :label="template.name" :value="template.id" />
        </el-select>
      </el-form-item>
      <el-card>{{ smsTemplatePreview }}</el-card>
      <el-form-item class="dialog-footer">
        <el-button  @click="handleVisible">取 消</el-button>
        <el-button  type="primary" @click="handleSendSms">确 定</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'item-dialog-sms',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    taskId: {
      type: [Number, String],
      required: true
    },
    loanId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      smsDialogFormVisible: false,
      smsDialog: {
        phones: []
      },
      tableData: [],
      smsTemplatePreview: '短信内容展示'
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'currentLoanItem',
      'contactsInfo',
      'smsTemplates'
    ])
  },
  watch: {
    contactsInfo(val) {
      const ops = val.find(item => {
        return item.relation === '本人'
      })
      this.tableData = [ops]
    }
  },
  created() {
    this.fetchContactsInfo({ taskId: this.taskId })
    this.fetchSmsTemplates()
  },
  methods: {
    ...mapActions([
      'fetchContactsInfo',
      'fetchSmsTemplates',
      'sendSMS',
      'getCollectionLog'
    ]),
    close() {
      this.$emit('hide')
    },
    handleVisible() {
      this.$emit('hide')
    },
    handleSmsReceiverListChange(val) {
      this.smsDialog.phones = val.map((item) => {
        return item.phone
      })
    },
    handleSmsTemplateChange(val) {
      this.smsTemplates.forEach((t) => {
        if (val === t.id) {
          this.smsTemplatePreview = t.content
        }
      })
    },
    handleSendSms() {
      this.smsDialog.phones.push(this.smsDialog.phone)
      if (this.smsDialog.phones.length < 1) return
      if (!this.smsDialog.template) return
      // 先这么清理一下吧
      // 临时fix TODO: clear dirty fix
      this.smsDialog.phones = this.smsDialog.phones.filter(n => n)
      const params = {
        taskId: this.taskId,
        agentId: this.currentUser.id,
        phones: this.smsDialog.phones.toString(),
        templateId: this.smsDialog.template
      }
      this.sendSMS({ params: params }).then((res) => {
        if (res.failed.length > 0) {
          this.$notify.error(res.failed + '发送失败')
        } else {
          this.getCollectionLog({ taskId: this.taskId, page: 1, size: 5 })
          this.$notify({
            title: '发送成功！',
            message: '3秒自动关闭',
            type: 'success'
          })
        }
        this.handleVisible()
        this.smsDialog.phones = []
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
